<template>
  <v-container
    id="ur-list"
  >
    <sala-header
      :payload="payload"
      v-if="isAuthenticated"
    >
    </sala-header>

    <v-row>
      <v-col>Formas de Apuração</v-col>
      <v-col
        class="text-right"
      >
        <app-modal-insert-ur
          v-if="isAdmin"
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadApuracores"
        >
          <template v-slot:title
            :edit="false"
          >
            Cadastrar formas de apuração
          </template>
        </app-modal-insert-ur>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >

        <template v-slot:item.nome="{ item }">
          <span>
            {{ item.nomeApuracao }}
          </span>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-insert-ur
                v-if="isAdmin"
                :object="item"
                :edit="true"
                :color="'warning'"
                :icon="'mdi-pencil'"
                @on-save="loadApuracores"
              >
                <template v-slot:title>
                  Editar Apuração
                </template>
              </app-modal-insert-ur>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.acoes_delete="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-delete
                    v-if="isAdmin"
                    :object="item"
                    @on-save="loadApuracores"
                  >
                    <template v-slot:title>
                      Deletar forma de Apuração
                    </template>
                  </app-modal-delete>
            </v-col>

            <v-col
              cols="1"
            >
            </v-col>
          </v-row>
        </template>

        <template slot="no-data">
          <span>
            Nenhuma forma de apuração retornada
          </span>
        </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertUr from './ModalInsert'
import { salaIndicadorApuracao } from '../API/salaIndicadorApuracaoApi'
import { mapActions, mapGetters } from 'vuex'
import AppModalDelete from './../components/ModalDelete'
import SalaHeader from '../../sala-principal/components/SalaHeader'

export default {
  components: {
    AppModalInsertUr,
    AppModalDelete,
    SalaHeader
  },
  data () {
    return {
      headers: [
        { text: 'Sala de indicadores de apuração', value: 'nome' },
        { text: 'Editar', value: 'acoes', sortable: false },
        { text: 'Excluir', value: 'acoes_delete', sortable: false }
      ],
      payload: []
    }
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setConsultorCondutorMunicipio',
      'setConsultorEspecialistaMunicipio',
      'setAnalistaMunicipio',
      'setADMunicipio'
    ]),
    loadApuracores () {
      this.setLoading(true)
      salaIndicadorApuracao.list()
        .then(resp => {
          this.payload = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter os dados')
        })
    }
  },
  mounted () {
    this.loadApuracores()
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'isAnalistaMunicipio',
      'isAuthenticated',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador'
    ])
  }
}
</script>
